import { IntlFormatters } from "react-intl";
import defineMessages from "../defineMessages";

const tempoFeelMessages = defineMessages({
    slow: {
        id: "meta.tempoFeel.slow",
    },
    moderate: {
        id: "meta.tempoFeel.moderate",
    },
    fast: {
        id: "meta.tempoFeel.fast",
    },
    swift: {
        id: "meta.tempoFeel.swift",
    },
    variable: {
        id: "meta.tempoFeel.variable",
    },
});

export const tempos = (fm: IntlFormatters["formatMessage"]) => [
    { value: "slow", label: fm(tempoFeelMessages["slow"]) },
    { value: "moderate", label: fm(tempoFeelMessages["moderate"]) },
    { value: "fast", label: fm(tempoFeelMessages["fast"]) },
    { value: "swift", label: fm(tempoFeelMessages["swift"]) },
    { value: "variable", label: fm(tempoFeelMessages["variable"]) },
];